module.exports = __webpack_public_path__ + "static/img/mirror_max.cdcf6a6e.png";